import React from 'react';

export default function Alarms() {
  return '';
}
